import React from 'react';
import { ButtonToolbar, Tabs, Tab } from 'react-bootstrap';
import { HOST, ROOT_URL, APP_URL } from '../../../../../config';
import { TextInput, CodeEditor, Multilingual, DropdownSelector, RadioButtonSelector } from 'hyperdb-utils';
import DisplayMessage from '../components/DisplayMessage';
import EmailComposer from './EmailComposer';

class Form extends React.Component {
  constructor(props) {
    super(props);
    this.handleSave = this.handleSave.bind(this);
    this.handleSend = this.handleSend.bind(this);
  }
  render() {
    return (
      <div>
        <div style={ { display: this.props.hide ? 'none' : 'block'} }>
          <Tabs defaultActiveKey={1}>
            <Tab eventKey={1} title="Compose message">
              <EmailComposer { ...this.props } />
            </Tab>
            <Tab eventKey={2} title="Preview">
              <DisplayMessage
                email={ this.props.objectData }
                showAttachments={ this.props.showAttachments }
                attachmentsBaseUrl={ this.props.attachmentsBaseUrl } />
            </Tab>
          </Tabs>
        </div>
        {
          this.props.showSaveButtons
            ? <div className="form-group">
                <ButtonToolbar>
                  <button type="button" className="btn btn-small" onClick={ this.handleSave }>
                    <i className="fas fa-save"></i> Save
                  </button>
                  <button type="button" className="btn btn-success btn-small" onClick={ this.handleSend } disabled={ !this.isValid(this.props.objectData) }>
                    <i className="fas fa-paper-plane-o"></i> Send
                  </button>
                </ButtonToolbar>
              </div>
            : null
        }
      </div>
    );
  }

  isValid(message) {
    return message.recipient && message.subject;
  }
  handleSave() {
    console.log('SAVE');
    // this.props.onSubmit('draft');
    this.handleSubmit('draft');
  }
  handleSend() {
    // this.props.onSubmit('send');
    this.handleSubmit('send');
  }
  handleSubmit(action) {
    console.log('URL', window.previousLocation);
    const reqUrl = action === 'send' ? '/send' : '/save-draft';
    this.props.api.message.setData({ loading: true });
    const xhr = new window.XMLHttpRequest();
    const formData = new window.FormData();
    const { attachments, ...data } = this.props.objectData;
    Object.keys(data).forEach(attr => {
      const value = data[attr];
      if (!!value) {
        if (typeof value === 'object') {
          formData.append(attr, JSON.stringify(value));
        } else {
          formData.append(attr, value);
        }
      }
    });
    let uploadUrl = HOST + ROOT_URL + APP_URL + '/messages' + reqUrl;
    if (data.id) {
      uploadUrl += `?id=${data.id}`;
    } else {
      formData.append('id', 0);
    }
    const previousAttachmentsNames = [];
    this.props.attachments.forEach((attachment, i) => {
      if (attachment.file) { // New uploaded file
        formData.append(`attachment-${i + 1}`, attachment.file);
      } else { // Old attachment
        previousAttachmentsNames.push(attachment.filename);
      }
    });
    formData.append('previousAttachments', JSON.stringify(previousAttachmentsNames));
    xhr.open('POST', uploadUrl, true);
    const localData = localStorage.getItem('currentUser') || '{}';
    const jwt = JSON.parse(localData).jwt;
    if (jwt) { xhr.setRequestHeader('Authorization', `Bearer ${jwt}`); }
    xhr.onload = () => {
      if (xhr.readyState === 4) {
        if (xhr.status >= 200 && xhr.status < 400) {
          const successMessage = action === 'send' ? 'Email sent' : 'Email saved';
          this.props.api.message.setData({ loading: false, submitSuccessful: true, successMessage });
          if (action === 'send') {
            this.props.api.routing.redirect(this.props.router, '/email/messages?filter=toProcess&folder=inbox');
          }
        } else {
          this.props.api.message.setData({ loading: false, error: xhr.statusText });
        }
      }
    };
    xhr.onerror = () => {
      this.props.api.message.setData({ loading: false, error: xhr.statusText });
    };
    xhr.send(formData);
  }
}

Form.propTypes = {
  api: React.PropTypes.object,
  router: React.PropTypes.object,
  objectData: React.PropTypes.object,
  updateEditedObject: React.PropTypes.func,
  availableLanguages: React.PropTypes.array,
  hide: React.PropTypes.bool,
  showSaveButtons: React.PropTypes.bool,
  showAttachments: React.PropTypes.bool,
  attachments: React.PropTypes.array,
};

export default Form;



// WEBPACK FOOTER //
// ./src/frontend/modules/email/message/containers/Form.jsx